import axios from "axios";
import type { ProPilotPolicyDto, ProPriceCatalogDto } from "dutyon-server/types";
import { httpClient } from "./httpClient";

const publicClient = axios.create({
  baseURL: httpClient.defaults.baseURL,
  timeout: 15000,
  withCredentials: false,
});
export async function getProPriceCatalog(): Promise<ProPriceCatalogDto> {
  return (await publicClient.get<ProPriceCatalogDto>("/pro/prices")).data;
}

export async function getProPilotPolicy(): Promise<{ pilot: ProPilotPolicyDto | null }> {
  return (await publicClient.get<{ pilot: ProPilotPolicyDto | null }>("/pro/pilot")).data;
}
